<div class="mt-2 d-flex flex-column passenger-details-container" *ngIf="flightDetails">
  <ng-container *ngFor="let passenger of selectedPassengers$ | async; let i = index">
    <div *ngIf="passenger?.passengerDetails?.passengerType !== 'Infant'">
      <div class="card border mb-3">
        <div class="p-3 d-flex border-bottom">
          <strong>
            {{ passenger?.passengerDetails?.gender === genderEnum.Male ? ('GENDER.MALE' | translate) : ('GENDER.FEMALE' | translate) }}
            {{ passenger?.passengerDetails?.firstName }} {{ passenger?.passengerDetails?.lastName }}
          </strong>
          <div class="ml-2 date-of-birth">
            {{ passenger?.passengerDetails?.dateOfBirth | formatDate }}
          </div>
        </div>
        <div *ngFor="let extras of passenger?.passengerExtras">
          <div>
            <ng-container *ngTemplateOutlet="productItem; context: { $implicit: extras }"></ng-container>
          </div>
        </div>
        <div class="border-bottom"></div>
        <div class="px-3 py-2 d-flex justify-content-end">
          <div class="mr-2">{{ 'PRINT.OTHER_TOTAL' | translate }}</div>
          <strong>
            € {{ flightDetails?.priceInfo?.pricePerPassenger[i]?.selectedExtrasPrice?.totalDisplayPrice | formatDecimals : culture }}
          </strong>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #productItem let-extras>
  <div *ngFor="let option of extras?.options">
    <div class="px-3 py-3 d-flex align-items-center" *ngIf="option?.isSelected">
      <div>
        <strong *ngIf="getContentByServiceType(extras.type) | async as content">{{ getContentTitle(extras.type, content) }}</strong>

        <div>{{ option.displayText }}</div>
      </div>
      <strong *ngIf="option?.displayPrice" class="ml-auto">€ {{ option?.displayPrice | formatDecimals : culture }}</strong>
    </div>
  </div>
</ng-template>
